import {NgModule} from '@angular/core';
import {FormDefinitionFieldSearchByLabelComponent} from "./form-definition-field-search-by-label.component";
import {SelectSearchDataModule} from "../../../../../../../components/common/select-search-data/select-search-data.module";
import {
    FormDefinitionFieldSelectFilterModule
} from '../form-definition-field-select-filter/form-definition-field-select-filter.module';
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {AsyncPipe, NgIf} from "@angular/common";

@NgModule({
    declarations: [
        FormDefinitionFieldSearchByLabelComponent,
    ],
    exports: [
        FormDefinitionFieldSearchByLabelComponent
    ],
    imports: [
        SelectSearchDataModule,
        FormDefinitionFieldSelectFilterModule,
        LoadingModule,
        NgIf,
        AsyncPipe,
    ]
})
export class FormDefinitionFieldSearchByLabelModule {
}
